import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight, Heart } from 'lucide-react';
import { Card } from '../ui/card';
import VerbinderCard from './VerbinderCard';

const HomeSidebar = ({ latestPosts, testimonials = [], t, onShareStory }) => (
  <>
    <VerbinderCard />
    {testimonials.length > 0 && (
      <Card className="p-5 bg-white border border-gray-100 shadow-soft">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-semibold text-sm text-gray-900 flex items-center gap-2">
            <Quote className="w-4 h-4 text-hoi-coral" aria-hidden="true" /> {t('home.latest_news')}
          </h3>
          <Link to="/verhalen" className="text-xs text-hoi-blue font-medium hover:underline">
            {t('home.all_news')}
          </Link>
        </div>
        <div className="space-y-3">
          {testimonials.slice(0, 3).map((story) => (
            <Link key={story.id} to={`/verhaal/${story.slug || story.id}`} className="flex gap-3 group">
              <div className="w-12 h-12 flex-shrink-0 bg-gray-50 overflow-hidden">
                {story.image_url ? (
                  <img src={story.image_url} alt={story.person_name} className="w-full h-full object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-hoi-coral/10"><Quote className="w-4 h-4 text-hoi-coral" /></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm text-gray-700 line-clamp-1 group-hover:text-hoi-coral transition-colors leading-snug">{story.title}</h4>
                <p className="text-xs text-muted-foreground line-clamp-1">{story.person_name} ({story.person_age}) — {story.person_wijk}</p>
              </div>
            </Link>
          ))}
        </div>
      </Card>
    )}

    <Card className="p-5 bg-white border border-gray-100 shadow-soft">
      <h3 className="font-heading font-semibold text-sm text-gray-900 mb-3">{t('sidebar.shortcuts')}</h3>
      <div className="space-y-1.5">
        <Link to="/activiteit-toevoegen" className="flex items-center gap-3 p-2.5 hover:bg-gray-50 transition-colors" data-testid="sidebar-create-link">
          <div className="w-8 h-8 bg-brand/10 flex items-center justify-center"><ArrowRight className="w-4 h-4 text-brand" /></div>
          <span className="text-sm font-medium text-gray-700">{t('sidebar.share_activity')}</span>
        </Link>
        <button
          type="button"
          onClick={onShareStory}
          className="w-full flex items-center gap-3 p-2.5 hover:bg-gray-50 transition-colors text-left"
          data-testid="sidebar-share-story-link"
        >
          <div className="w-8 h-8 bg-hoi-coral/10 flex items-center justify-center"><Heart className="w-4 h-4 text-hoi-coral" /></div>
          <span className="text-sm font-medium text-gray-700">{t('sidebar.share_story')}</span>
        </button>
      </div>
    </Card>
  </>
);

export default HomeSidebar;
